document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get("variant");

  if (variantId) {
    const swatchInput = document.querySelector(`input[type="radio"][value="${variantId}"]`);
    
    if (swatchInput) {
      // Simulate user selection to trigger theme JS
      swatchInput.checked = true;
      swatchInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const variantIdFromUrl = new URLSearchParams(window.location.search).get('variant');
  const variantSelect = document.querySelector('[name="id"]');

  if (variantIdFromUrl && variantSelect) {
    variantSelect.value = variantIdFromUrl;
    variantSelect.dispatchEvent(new Event('change', { bubbles: true }));

    // Force re-select the active thumbnail image if gallery not updated
    const activeThumb = document.querySelector(
      `.product-gallery__thumbnail[data-media-id="${variantIdFromUrl}"]`
    );
    if (activeThumb) activeThumb.click(); // triggers image change
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get("variant");

  if (!variantId) return;

  const variantSelect = document.querySelector('[name="id"]');
  if (!variantSelect) return;

  const matchingOption = Array.from(variantSelect.options).find(
    opt => opt.value === variantId
  );

  if (matchingOption) {
    variantSelect.value = variantId;
    variantSelect.dispatchEvent(new Event("change", { bubbles: true }));

    // Also simulate clicking the correct swatch (if available)
    const swatch = document.querySelector(`[data-variant-id="${variantId}"]`);
    if (swatch) swatch.click();
  }
});